import { Container, Stack } from "@mui/material";

const PrivacyPDF = () => {
  return (
    <Container sx={{
      height: 'calc(100vh - 70px)',
      width: '100vw',
    }}>
      <iframe
        src="https://storage.googleapis.com/tcs-salsa.appspot.com/MarketingAssets/Circle4life_Data_Privacy_Policy_v2.0.pdf"
        height="100%"
        width="100%"
      />
    </Container>
  );
};

export default PrivacyPDF;
